import { WorkspaceEntity } from './utils';

export const isAncestorOfSelected = (
  workspaceId: string,
  selectedId: string | null,
  workspaces: Record<string, WorkspaceEntity>
): boolean => {
  if (!selectedId) return false;

  let current = workspaces[selectedId];
  while (current?.parentId) {
    if (current.parentId === workspaceId) return true;
    current = workspaces[current.parentId];
  }

  return false;
};

export const shouldExpandForSelection = (
  workspaceId: string,
  selectedId: string | null,
  workspaces: Record<string, WorkspaceEntity>
): boolean => {
  if (!selectedId) return false;

  if (workspaceId === selectedId) {
    return (workspaces[workspaceId]?.childWorkspaces.length ?? 0) > 0;
  }

  return isAncestorOfSelected(workspaceId, selectedId, workspaces);
};
